import { render } from "./MarketPlaceHome.vue?vue&type=template&id=5366814c"
import script from "./MarketPlaceHome.vue?vue&type=script&lang=js"
export * from "./MarketPlaceHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__